import { Flex, FlexProps, Box } from 'theme-ui'
import { Text } from 'components'
import { FilterIcon } from 'components/Icon'

type FilterButtonProps = FlexProps & {
  disabled?: boolean
}

export function FilterButton({ disabled = false, ...rest }: FilterButtonProps) {
  return (
    <Flex
      sx={{
        color: 'text',
        userSelect: 'none',
        transition: '0.4s ease-in-out',
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
      data-cy="filter"
      {...rest}>
      <Box sx={{ mr: 2 }}>
        <FilterIcon />
      </Box>
      <Text sx={{ fontWeight: 'heading' }}>Filter</Text>
    </Flex>
  )
}
